// extracted by mini-css-extract-plugin
export default {"wrapper":"avatar_wrapper--IbQJx styles_noselect--NE5ba","medium":"avatar_medium--PWlkL"};